import CommonProductCatalogue from './CommonProductCatalogue';

export default class SGProductCatalogue extends CommonProductCatalogue{

    componentDidMount(){
        super.componentDidMount();

        this.isReloadRequired = !this.userLoggedIn;        
    }
   
    getSelectedIndex(indVal){
        const chosenGradeFromURL = this.getProdFromQryParam();

        if(window.catalog_qry_param_support[this.getCategory()] && !isNaN(window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL])){
            return window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL];
        }

        return super.getSelectedIndex(indVal);
    }

	getCategory(){
       return "SG_PLP";
    }
	
	//setting coupon false
	isCouponAllowed(){
        return (window.sg_plp_discount_available);
    }

    couponAttrPrefix(){
    	return "sg1";
    }

    onBillingFormClose(){
        if(this.isReloadRequired){
            window.location.reload();    
        }        
    }
}


// WEBPACK FOOTER //
// ./src/views/others/SGProductCatalogue.js